"use strict";

import onInitModulesInsScope from "./onInitModulesInScope";
import onInitModulesInScope from "./onInitModulesInScope";
import initModulesInScope from "@elements/init-modules-in-scope";
import * as affix from './affix';

onInitModulesInScope(
    affix.createInitInScope({mediaQuery: '(min-width: 768px)'}, {
        base: '.js-hotspot-affix',
        placeholder: '.js-hotspot-affix__placeholder',
        container: '.js-hotspot-affix__container'
    })
);

export function init () {
    let $hotspotAreas = $('.js-hotspot-area');

     $hotspotAreas.each(function(){
         let $hotspotArea = $(this);
         let $pois = $hotspotArea.find('.js-hotspot-area__hotspot');
         let $teasers = $hotspotArea.find('.js-hotspot-area__teaser');

         initHotspots($hotspotArea, $pois, $teasers);

         $hotspotArea.find('.js-hotspot-area__form').on('success.ajax-form', function(e){
             $teaser = $hotspotArea.find('.js-hotspot-area__teaser');
             initHotspots($hotspotArea, $pois, $teasers);
         });
     });
}

function initHotspots($hotspotArea, $pois, $teasers){
    $pois.each(function(){
        let $this = $(this);
        let id = $this.attr('data-hotspot-id');

        $this.removeClass('has-teaser');
        $this.removeClass('is-active');

        $teasers.each(function(){
            if($(this).attr('data-hotspot-id') === id){
                $this.addClass('has-teaser');
            }
        });
    });

    $pois.on('click', function(e){
        $pois.removeClass('is-active');
        $teasers.removeClass('is-active');

        let target;
        if($(e.target).hasClass('js-hotspot-area__hotspot')){
            target = $(e.target);
        }else{
            target = $(e.target).closest('.js-hotspot-area__hotspot');
        }
        target.addClass('is-active');

        let id = target.attr('data-hotspot-id');
        $teasers.each(function(){
            if($(this).attr('data-hotspot-id') === id){
                if (matchMedia('(max-width: 767px)').matches) {
                    scrollIntoViewWithOffset(this, 0, $('.js-hotspot-area__scroll')[0]);
                    $(this).addClass('is-active');
                }else{
                    scrollIntoViewWithOffset(this, 175, window);
                    $(this).addClass('is-active');
                }

            }
        });
    });

    $teasers.on('keyup', function(e){
        let $parent = $(e.target).closest('.js-hotspot-area__teaser');
        console.log(e.key)

        if(e.key === 'Escape'){
            $pois.each(function(){
                if($(this).data('hotspot-id') === $parent.data('hotspot-id')){
                    $(this).find('.js-hotspot-area__hotspot-name').addClass('sr-only');
                }
            })
        } else if (e.key === 'Enter' || e.key === ' ') {
            $pois.each(function(){
                if($(this).data('hotspot-id') === $parent.data('hotspot-id')){
                    $(this).find('.js-hotspot-area__hotspot-name').removeClass('sr-only');
                }
            });
        }
    });

    $teasers.on('mouseover focusin', function(e){
        let $parent = $(e.target).closest('.js-hotspot-area__teaser');

        $pois.each(function(){
            if($(this).data('hotspot-id') === $parent.data('hotspot-id')){
                $(this).addClass('is-active');
                $parent.addClass('is-active');
                $(this).find('.js-hotspot-area__hotspot-name').removeClass('sr-only');
            }
        })

    });
    $teasers.on('mouseleave focusout', function(e){
        let $parent = $(e.target).closest('.js-hotspot-area__teaser');

        $pois.each(function(){
            if($(this).data('hotspot-id') === $parent.data('hotspot-id')){
                $(this).removeClass('is-active');
                $parent.removeClass('is-active');
            }
        });
    });
}

const scrollIntoViewWithOffset = (element, offset, container) => {
    container.scrollTo({
        behavior: 'smooth',
        top:
            element.getBoundingClientRect().top -
            document.body.getBoundingClientRect().top -
            offset,
    })
}